import { matchUrl } from "../lib/urlMatcher";
export interface UrlFilterParams {
    urls: string;
}

export function urlFilter(params: UrlFilterParams) {
    this.params = params;
    let currentPath = location.pathname;
    let urls = this.params.urls.split(",");
    let match = matchUrl(urls, currentPath);
    return !match;
}
